import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const DataTablePreferencesUserContext = createContext(null);
export function DataTablePreferencesProvider({ children, userId, }) {
    return (_jsx(DataTablePreferencesUserContext.Provider, { value: userId, children: children }));
}
export function useDataTablePreferencesUser() {
    return useContext(DataTablePreferencesUserContext);
}
//# sourceMappingURL=data-table-preferences-provider.js.map